export default __webpack_public_path__ + "static/media/Flag_of_Myanmar.280279af.svg";